import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-su_038",
  "use": "icon-su_038-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"icon-su_038\"><defs><style>#icon-su_038 .cls-1{fill:none;opacity:0;}</style></defs><g id=\"icon-su_038_レイヤー_2\" data-name=\"レイヤー 2\"><g id=\"icon-su_038_icon\"><rect class=\"cls-1\" width=\"12\" height=\"12\" /><polygon class=\"cls-2\" points=\"6 9.56 0.29 3.85 1.71 2.44 6 6.73 10.29 2.44 11.71 3.85 6 9.56\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol